import React, { useEffect, useState } from 'react';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '../ui/dialog';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Textarea } from '../ui/textarea';
import { Trees } from 'lucide-react';
import { areaHa } from '../../lib/geo';

export const FellingAreaDialog = ({ open, onOpenChange, area, geometry, onSave, saving }) => {
  const [form, setForm] = useState({ name: '', affirmation_number: '', notes: '' });

  useEffect(() => {
    if (!open) return;
    setForm({
      name: area?.name || '',
      affirmation_number: area?.affirmation_number || '',
      notes: area?.notes || ''
    });
  }, [open, area]);

  const computed = areaHa(geometry || area?.geometry);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md" data-testid="felling-area-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2"><Trees className="w-5 h-5 text-red-600" /> {area ? 'Labot cirsmu' : 'Jauna cirsma'}</DialogTitle>
          <DialogDescription>
            {computed ? `Aprēķinātā platība: ${computed} ha.` : 'Kontūra iezīmēta kartē.'} Platība tiek pārrēķināta automātiski pēc kontūras.
          </DialogDescription>
        </DialogHeader>
        <form
          className="space-y-3"
          onSubmit={(e) => { e.preventDefault(); onSave({ name: form.name.trim() || 'Cirsma', affirmation_number: form.affirmation_number.trim() || null, notes: form.notes.trim() || null }); }}
        >
          <div className="space-y-1">
            <Label>Nosaukums</Label>
            <Input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} placeholder="Piem.: Cirsma 1 (kv. 12, nog. 3)" autoFocus data-testid="felling-area-name" />
          </div>
          <div className="space-y-1">
            <Label>Apliecinājuma Nr. (VMD)</Label>
            <Input value={form.affirmation_number} onChange={(e) => setForm({ ...form, affirmation_number: e.target.value })} placeholder="693126465" data-testid="felling-area-number" />
          </div>
          <div className="space-y-1">
            <Label>Piezīmes</Label>
            <Textarea rows={2} value={form.notes} onChange={(e) => setForm({ ...form, notes: e.target.value })} placeholder="Cirtes veids, sugas, īpaši nosacījumi..." data-testid="felling-area-notes" />
          </div>
          <div className="flex justify-end gap-2 pt-1">
            <Button type="button" variant="outline" onClick={() => onOpenChange(false)} data-testid="felling-area-cancel">Atcelt</Button>
            <Button type="submit" disabled={saving} className="bg-[#1F3D2B] hover:bg-[#2a5039]" data-testid="felling-area-save">{saving ? 'Saglabā...' : 'Saglabāt cirsmu'}</Button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default FellingAreaDialog;
